module.exports = __webpack_public_path__ + "static/img/one.fadc7df0.png";